<div
  class="d-flex mb-1"
  [ngClass]="
    centerAlignedTariffLink
      ? 'justify-content-center mb-2'
      : 'justify-content-between'
  "
>
  @if (!centerAlignedTariffLink) {
    <div class="fw-bold">
      {{ tariffModalDescriptionLabel }}
    </div>
  }
  <button
    class="btn p-0 border-0 btn-link text-end"
    [ngClass]="centerAlignedTariffLink ? 'fw-bold' : ''"
    (click)="viewTariffs.emit()"
    wlAutomationId="offer-trigger-aom-button"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: { componentName: 'contractdetail' },
      field: 'toon prijs samenstelling',
      eventType: 'link-click',
    }"
  >
    {{ tariffModalLinkTextLabel }}
  </button>
</div>
